import { render, staticRenderFns } from "./InvoiceContent.vue?vue&type=template&id=4ff92e10&scoped=true"
import script from "./InvoiceContent.vue?vue&type=script&lang=js"
export * from "./InvoiceContent.vue?vue&type=script&lang=js"
import style0 from "./InvoiceContent.vue?vue&type=style&index=0&id=4ff92e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff92e10",
  null
  
)

export default component.exports